import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  pure,
  setPropTypes,
  withStateHandlers,
  branch,
  renderComponent,
  setDisplayName
} from 'recompose';

import withErrors from '../Error/ErrorHandler';
import { MenuModel } from '../../../model';

import {
  StyledBoxSpecial,
  StyledBoxSpecialWeekly,
  StyledBoxPricipal,
  StyledBoxMenu,
  StyledBoxMenuWeekly,
  StyledDay,
  StyledTitleSpecial,
  StyledTitleSpecialWeekly,
  StyledInterior,
  StyledInteriorWeekly,
  StyledContent,
  StyledTitleList,
  StyledListFood,
  StyledBoxDown,
  StyledIconAllergies,
  TabsMenu,
  TabsMenuWeekly,
  StyledTab,
  StyledMenuWellness,
  StyledText,
  StyledTextWeekly,
  StyledIcon,
  StyledIconWeekly,
  StyledBoxImages,
  StyledWrapperBox,
  StyledBoxMessage,
  StyledBoxMessageWeekly,
  StyledMessageTitle,
  DetailMessageTitle,
  StyledIconRazor,
  StyledTabWeekly,
  StyledBookTable
} from './style';
import {
  Allergies,
  Wellness,
  WellnessText,
  Razor,
  ReservarMesa
} from '../../../../assets/images/index';
import MenuObjetive from './MenuObjetive';
import Icon from '../../core/Icon';
import { getFile } from '../../../utils/resources';

import { WELLNESS_MENU } from '../../../constants/content';

const MenuDay = ({
  menuDate,
  menuWellness,
  allergensUrl,
  dishesCategories,
  especial,
  imageUrl,
  title,
  changeTab,
  weekly,
  activeTab
}) => {
  // Styles when weekly or not
  const BoxMenu = weekly ? StyledBoxMenuWeekly : StyledBoxMenu;
  const Text = weekly ? StyledTextWeekly : StyledText;
  const Interior = weekly ? StyledInteriorWeekly : StyledInterior;
  const Icons = weekly ? StyledIconWeekly : StyledIcon;
  const BoxSpecial = weekly ? StyledBoxSpecialWeekly : StyledBoxSpecial;
  const TitleSpecial = weekly ? StyledTitleSpecialWeekly : StyledTitleSpecial;
  const Tabs = weekly ? TabsMenuWeekly : TabsMenu;
  const TabMenu = weekly ? StyledTabWeekly : StyledTab;

  return (
    <BoxMenu>
      <StyledBoxPricipal>
        {especial && (
          <BoxSpecial imageUrl={imageUrl}>
            <TitleSpecial>{title}</TitleSpecial>
          </BoxSpecial>
        )}

        {!weekly && <StyledDay date={menuDate} />}

        {dishesCategories.length && (
          <Tabs vertical activeIndex={activeTab}>
            {dishesCategories.map((item, index) => (
              <TabMenu
                label={item.title}
                key={item.id}
                id={item.id}
                hidden={item.id === WELLNESS_MENU.id}
                active={index === activeTab}
                onClick={() => changeTab(index)}
                icon={
                  item.id === WELLNESS_MENU.id && (
                    <StyledBoxImages wellness={item.id === WELLNESS_MENU.id}>
                      <Icons size="l" svg={Wellness} />
                      <Text size="l" svg={WellnessText} />
                    </StyledBoxImages>
                  )
                }
                wellness={item.id === WELLNESS_MENU.id}
              >
                <Interior columns={item.dishesSubcategories.length}>
                  {item.dishesSubcategories.map(i => (
                    <StyledContent key={i.title}>
                      {i.title && <StyledTitleList>{i.title}</StyledTitleList>}
                      {i.dishes.map((c, x) => (
                        <StyledListFood key={`${c.id + x}`}>
                          {c.name.charAt(0).toUpperCase() + c.name.slice(1)}
                        </StyledListFood>
                      ))}
                    </StyledContent>
                  ))}
                </Interior>
              </TabMenu>
            ))}
          </Tabs>
        )}
      </StyledBoxPricipal>

      {!weekly && (
        <StyledMenuWellness>
          <MenuObjetive menu={menuWellness} />
        </StyledMenuWellness>
      )}

      <StyledBoxDown className="menuHome">
        <StyledBookTable href="#" target="_blank" rel="noopener noreferrer">
          <Icon className="icon-reserv" size="m" svg={ReservarMesa} />
          Reserva tu mesa
        </StyledBookTable>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        {allergensUrl && (
          <a
            href={getFile(allergensUrl)}
            target="_blank"
            rel="noopener noreferrer"
            title="alérgenos"
          >
            <StyledIconAllergies size="l" svg={Allergies} />
          </a>
        )}
      </StyledBoxDown>
    </BoxMenu>
  );
};

MenuDay.propTypes = {
  weekly: PropTypes.bool
};

MenuDay.defaultProps = {
  weekly: false
};

const NoMenu = ({ weekly }) => {
  const BoxMessage = weekly ? StyledBoxMessageWeekly : StyledBoxMessage;
  return (
    <BoxMessage>
      <StyledWrapperBox>
        <StyledMessageTitle>
          El menú para este día aún no está disponible.
          <DetailMessageTitle> En breve lo publicaremos.</DetailMessageTitle>
        </StyledMessageTitle>
        <p>Disculpa las molestias.</p>
        <StyledIconRazor svg={Razor} />
      </StyledWrapperBox>
    </BoxMessage>
  );
};

NoMenu.propTypes = {
  weekly: PropTypes.bool
};

NoMenu.defaultProps = {
  weekly: false
};

export default compose(
  withErrors(),
  setDisplayName('MenuDay'),
  setPropTypes({
    ...MenuModel
  }),
  branch(({ menuDate }) => !menuDate, renderComponent(NoMenu)),
  branch(
    ({ dishesCategories }) => !dishesCategories.length,
    renderComponent(NoMenu)
  ),
  withStateHandlers(
    ({ initialActive = 0 }) => ({
      activeTab: initialActive
    }),
    {
      changeTab: () => value => ({ activeTab: value })
    }
  ),
  pure
)(MenuDay);
